import { render, staticRenderFns } from "./preference-migration-modal.vue?vue&type=template&id=848714f0&scoped=true&"
import script from "./preference-migration-modal.vue?vue&type=script&lang=tsx&"
export * from "./preference-migration-modal.vue?vue&type=script&lang=tsx&"
import style0 from "./preference-migration-modal.vue?vue&type=style&index=0&id=848714f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848714f0",
  null
  
)

export default component.exports